import React from 'react';
import {Typography} from '@mui/material';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';

const SettingsPaneDescriptionRoot = styled('div')(({theme}) => ({
	// background: theme.palette.custom.background.accent,
	// background: 'rgb(45,45,45)',
	// ...theme.mixins.positionSticky,
	// top: 0,
	width: '50%',
	flex: '0 0 auto',
	// [theme.breakpoints.down('sm')]: {
	// 	background: 'transparent',
	// },
}));

const SettingsPaneDescriptionWrapper = styled('div')(({theme}) => ({
	// ...theme.mixins.positionSticky,
	padding: theme.spacing(2),
	top: 0,
}));

const SettingsPaneDescriptionSecondary = styled(Typography)(({theme}) => ({
	color: theme.palette.text.secondary,
	fontSize: 14,
}));

export interface SettingsPaneDescriptionProps
	extends React.DetailedHTMLProps<
			React.HTMLAttributes<HTMLDivElement>,
			HTMLDivElement
		>,
		React.PropsWithChildren<{
			primary: string;
			required?: boolean;
			secondary?: string;
		}> {}

export const SettingsPaneDescriptionPrimitive = ({
	children,
	primary,
	required,
	secondary,
	...props
}: SettingsPaneDescriptionProps) => {
	return (
		<SettingsPaneDescriptionRoot {...props}>
			<SettingsPaneDescriptionWrapper>
				<Typography variant="body1">
					{primary}
					{required ? ' *' : ''}
				</Typography>

				{secondary && (
					<SettingsPaneDescriptionSecondary
						variant="body2"
						style={{
							wordBreak: 'break-word',
						}}
					>
						{secondary}
					</SettingsPaneDescriptionSecondary>
				)}

				{children}
			</SettingsPaneDescriptionWrapper>
		</SettingsPaneDescriptionRoot>
	);
};

export const SettingsPaneDescription = SettingsPaneDescriptionPrimitive;

export default SettingsPaneDescription;
